// Kept in redux rather than page state so the chosen driver survives leaving the harness and coming back.
// The diff viewer hands the harness a range to start from, and keeps where to send the operator back to.
const initialState = {
    driver: null,
    range: null,
    diffViewerReturn: null
};

const rulesEngineReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_RULES_ENGINE_DRIVER":
            return {
                ...state,
                driver: action.payload
            };
        case "SET_RULES_ENGINE_RANGE":
            return {
                ...state,
                range: action.payload
            };
        case "SET_RULES_ENGINE_DIFF_VIEWER_RETURN":
            return {
                ...state,
                diffViewerReturn: action.payload
            };
        case "RESET_STORE":
            return initialState;
        default:
            return state;
    }
};

export default rulesEngineReducer;
